import React, { useEffect, useState } from "react";
import api from "services/api";
import { Link, useNavigate } from "react-router-dom";
import { MembershipPlans } from "services/api.config";

const ShowAllPlans = ({ hideHeader }) => {
  const navigate = useNavigate();
  const [memberships, setMemberships] = useState([]);

  useEffect(() => {
    fetchMembership();
  }, []);

  const fetchMembership = () => {
    api.get(`/${MembershipPlans}`).then((res) => {
      if (res?.data?.data?.membershipPlans) {
        setMemberships(res?.data?.data?.membershipPlans);
      }
    });
  };

  const getImage = (type) => {
    switch (type) {
      case "Individual":
        return "../../assets/img/illustrations/page-pricing-basic.png";
      case "Family":
        return "../../assets/img/illustrations/page-pricing-standard.png";
      case "Corporate":
        return "../../assets/img/illustrations/page-pricing-enterprise.png";
      default:
        return "../../assets/img/illustrations/page-pricing-basic.png";
    }
  };

  return (
    // <div className="container-xxl flex-grow-1 container-p-y">
    <div className="row pricing-section">
      {!hideHeader && <h3 class="text-center mb-2 mt-4">Pricing Plans</h3>}
      {memberships.map((membership, index) => {
        return (
          <div className="col-md-4 col-12 mt-2 d-flex" key={index}>
            <div className="card border rounded shadow-none w-100 d-flex flex-column">
              <div className="card-body d-flex flex-column">
                <div className=" pt-2 text-center">
                  <img
                    src={getImage(membership.membership_type)}
                    alt="Enterprise Image"
                    height="100"
                  />
                </div>
                <h3
                  className="card-title text-center text-capitalize mb-1"
                  style={{ minHeight: "80px" }}
                >
                  {membership.title}
                </h3>
                <p
                  className="text-center"
                  dangerouslySetInnerHTML={{ __html: membership.short_text }}
                />

                {membership.membership_type !== "Corporate" && (
                  <div className="text-center">
                    <div className="pricing-display">
                      <span className="pricing-currency">₹</span>
                      <h4
                        className="price-toggle price-yearly"
                        style={{ fontWeight: 500 }}
                      >
                        {membership.package_price}
                      </h4>
                      <span className="pricing-duration">
                        /{membership.duration_type}
                      </span>
                      <span className="taxes-text">+ Taxes</span>
                    </div>
                  </div>
                )}
                <div className="flex-grow-1">
                  <p
                    className="ps-3 my-4 pt-2  short-description"
                    dangerouslySetInnerHTML={{
                      __html: membership.short_description,
                    }}
                  />
                </div>

                <button
                  className="btn btn-label-primary d-grid w-100 mt-auto"
                  onClick={() => {
                    if (membership.membership_type === "Corporate") {
                      navigate("/contactUs");
                      return;
                    }
                    if (localStorage.getItem("user")) {
                      navigate(`/membershipForm/${membership.id}`);
                    } else {
                      navigate("/login");
                    }
                  }}
                >
                  {membership.membership_type === "Corporate"
                    ? "Contact Us"
                    : "Apply"}
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
    // </div>
  );
};

export default ShowAllPlans;
